import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { SelectListItemDto, UserPermissionServiceProxy, WarehouseSelectListDto } from '../../../../../../../../../shared/service-proxies/service-proxies';
import { NgForm } from '@angular/forms';
import { TestService } from 'test/service/test.service';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';

@Component({
  selector: 'kt-to-request-warehouse',
  templateUrl: './to-request-warehouse.component.html',
  styleUrls: ['./to-request-warehouse.component.scss']
})
export class ToRequestWarehouseComponent implements OnInit, OnDestroy {

  //@ViewChild('f', { static: true }) subForm: NgForm;

  //Dynamic olarak oluşturulan component içerisinde ki datayı 
  //parent component içerisinde yakalamamızı sağlar.
  //Yayınlancak dynamic component dataları demektir.
  dynamicComponentObject = new Subject();

	
  //Combobox içerisine basılacak datayı tutarız.
	warehouses = new BehaviorSubject<WarehouseSelectListDto[]>([]);

  //Seçilen Deponun objesini alır.
  //Teslim alınacak depo demektir(merkez depodan depoya talep)
	selectedWarehouse = new WarehouseSelectListDto();


	constructor(private _userPermissionService: UserPermissionServiceProxy,
		private _testService: TestService,
		private customLocalization: CustomLocalizationService

) {
		
	}

  ngOnInit() {

	  this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TRANSFER.HEADER"));
	  this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TRANSFER.SUBHEADER"));


	  //Kullanıcının yetkisi olduğu Teslim alınacak depoların listesini bize verir.
	  this._userPermissionService.getToRequestWarehouseByUserAuths()
		  .subscribe((wareHouses: WarehouseSelectListDto[]) => {
			  this.warehouses.next(wareHouses);
		  })

	  
  }

  //warehouse combobox'ı change işlemi yapılınca bu methoda gönderiyoruz.
  //yapılan değişikliği dynamicComponentDataToBePublished(yayınlayımız ile dynamic component içerisinde anlık olarak yakalıyoruz.)
  //şeçmez ise zorunlu olduğunu belirten bir mesaj çıkartıyoruz.
  onChangeWareHouse(){

	  this.dynamicComponentObject.next(this.selectedWarehouse);

	  //console.log("form bilgileri" + this.subForm.valid);
  }

	ngOnDestroy() {

		this.dynamicComponentObject.unsubscribe();
		this.warehouses.unsubscribe();

		this._testService.setTitle(" ");
		this._testService.setDesc(" ");
	}


}
